import React, { Component } from "react";
import ProductHeader from "../ProductDetails/ProductHeader";
import { ReactComponent as Error } from "../CheckoutProcess/assets/error.svg";
import { connect } from "react-redux";
import ActionButton from "../ActionButton";

class DownloadFailed extends Component {
  render() {
    const language = this.props.language;
    return (
      <div>
        <Error width="100" height="100" />
        <h1 className="mt-3" dir={language == "english" ? "ltr" : "rtl"}>
          {language == "english" ? "Oops.." : ""}
        </h1>
        <p
          className="mt-3 mx-auto mb-0"
          style={{ fontSize: "1rem", width: "90%" }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {language === "english"
            ? "There are no downloads available "
            : "حاول مره اخرى"}
        </p>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.store.language
  };
};

export default connect(mapStateToProps)(DownloadFailed);
